import type { LineageGraph } from './types';
import type { NpcCreature } from '@/domain/npc/types';

/** Verdadeiro se `aId` é pai/mãe direto de `bId`, ou vice-versa. */
export function isDirectRelation(g: LineageGraph, aId: string, bId: string): boolean {
  const aNode = g.nodes[aId];
  const bNode = g.nodes[bId];
  if (aNode && aNode.parentIds.includes(bId)) return true;
  if (bNode && bNode.parentIds.includes(aId)) return true;
  return false;
}

/**
 * NPCs elegíveis pra cruzar com `activeId`: vivos, em estágio adult, e sem
 * relação de pai/filho direto com o ativo (avós, irmãos, tios e primos ficam
 * liberados).
 */
export function getEligiblePartners(
  npcs: ReadonlyArray<NpcCreature>,
  lineage: LineageGraph,
  activeId: string,
): NpcCreature[] {
  return npcs.filter(
    (n) => !n.dead && n.stage === 'adult' && n.id !== activeId && !isDirectRelation(lineage, activeId, n.id),
  );
}
